import { useAIAssistantForPage } from '@euler/app/components/ai/pageContext';
import { useTaskContext } from '@euler/app/flows/task/functions/TaskContext';
import { useIsMobileLayout } from '@euler/functions/responsiveness';
import { wrapNavigatorScreen } from '@euler/functions/wrapNavigatorScreen';
import { WiredPreInspectionScreenContent } from './components/WiredPreInspectionScreenContent';
import { WiredPreInspectionScreenContentForIpad } from './components/WiredPreInspectionScreenContent.iPad';

export const PreInspectionScreen = wrapNavigatorScreen(
  () => {
    const { taskNo } = useTaskContext();
    useAIAssistantForPage('pre_inspection', { taskNo });
    const isMobile = useIsMobileLayout();
    if (isMobile) {
      return <WiredPreInspectionScreenContent />;
    }
    return <WiredPreInspectionScreenContentForIpad />;
  },
  {
    headerShown: false,
  },
);
